<template>
    <div class="winfoengine risk-factor-page">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-6">
                    <h2>Screening List Categorisation</h2>
                </div>
                <div class="col-md-6 text-right">
                    <strong><em>Name Screening Last Updated At</em></strong> :
                    {{ $moment(lastUpdatedAt).format('MMM D, YYYY') }} <br />
                    <strong><em>Categorisations Last Configured At</em></strong>
                    :
                    {{ $moment(lastListUpdatedAt).format('MMM D, YYYY') }}
                </div>
            </div>
            <div class="row">
                <div class="col-md-9"></div>
                <div class="col-md-3 d-flex justify-content-end">
                    <b-button
                        :disabled="loading || fieldsToUpdate.length < 1"
                        variant="primary"
                        size="sm"
                        @click="updateList"
                        ><i style="font-size: 14px" class="icon-done"></i>
                        Update</b-button
                    >
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <b-button
                        :disabled="loading"
                        variant="primary"
                        size="sm"
                        @click="resetCompleteList"
                        ><i style="font-size: 14px" class="icon-loop"></i> Reset
                        List</b-button
                    >
                </div>
            </div>
        </div>

        <!-- Tabs Start  -->
        <div class="mt-4">
            <base-table-spinner v-if="loading"></base-table-spinner>
            <b-tabs
                v-else
                v-model="tabIndex"
                active-nav-item-class="font-weight-bold"
                active-tab-class="bg-white p-4"
                content-class=""
            >
                <b-tab :title-link-class="tabLinkClass(0)">
                    <template #title>
                        <h5>SANCTION</h5>
                    </template>
                    <div>
                        <ScreningListTable
                            :add-field-to-update="addFieldToUpdate"
                            :data="sanctionData"
                            :fields="[
                                'Sanctions',
                                'Publisher',
                                'Status',
                                'Action',
                            ]"
                        />
                    </div>
                </b-tab>
                <b-tab :title-link-class="tabLinkClass(1)">
                    <template #title>
                        <h5>SPECIAL INTEREST</h5>
                    </template>
                    <div>
                        <ScreningListTable
                            :add-field-to-update="addFieldToUpdate"
                            :data="specialInterestData"
                            :fields="[
                                'SPECIAL INTERESTS',
                                'Publisher',
                                'Status',
                                'Action',
                            ]"
                        />
                    </div>
                </b-tab>
                <b-tab :title-link-class="tabLinkClass(2)">
                    <template #title>
                        <h5>PEP</h5>
                    </template>
                    <div>
                        <ScreningListTable
                            :add-field-to-update="addFieldToUpdate"
                            :data="pepData"
                            :fields="['PEP', 'Publisher', 'Status', 'Action']"
                        />
                    </div>
                </b-tab>
                <!-- <b-tab :title-link-class="tabLinkClass(3)">
                    <template #title>
                        <h5>SMART SEARCH</h5>
                    </template>
                    <div>
                        <ScreningListTable :addFieldToUpdate="addFieldToUpdate" :data="smartSearchData"
                            :fields="['SMART SEARCH', 'Publisher', 'Status', 'Action']" />
                    </div>
                </b-tab> -->
            </b-tabs>
        </div>
    </div>
</template>

<script>
import ScreningListTable from './ScreeningListTable.vue'
import resource from '@/api/resource'
import { mapGetters } from 'vuex'
import request from '../../../utils/request'
const listCustomizAPI = new resource('configurations/categorize')
const generate = new resource('configurations/categorize/generateList')

export default {
    components: {
        ScreningListTable,
    },
    data() {
        return {
            tabIndex: 0,
            lastUpdatedAt: new Date(),
            lastListUpdatedAt: new Date(),
            list: [],
            fieldsToUpdate: [],
            country: process.env.VUE_APP_COUNTRY,
        }
    },
    computed: {
        ...mapGetters(['showPageLoader', 'loading', 'dataSegmentId']),
        sanctionData() {
            console.log('list', this.list)
            if (!this.list) return []
            return this.list.filter((el) => el.category == 'Sanction')
        },
        specialInterestData() {
            if (!this.list) return []
            return this.list.filter((el) => el.category == 'Special Interest')
        },
        pepData() {
            if (!this.list) return []
            return this.list.filter((el) => el.category == 'PEP')
        },
        smartSearchData() {
            if (!this.list) return []
            return this.list.filter((el) => el.category == 'Smart Search')
        },
    }, // End of Component > computed
    watch: {
        dataSegmentId(val) {
            if (val) {
                this.getListData()
            }
        },
    },
    mounted() {
        this.getListData()
    }, // End of Component > mounted

    methods: {
        tabLinkClass(index) {
            if (this.tabIndex === index) {
                return [
                    'font-weight-bold',
                    'text-dark',
                    'tabHeading',
                    'w-210',
                    'text-center',
                ]
            } else {
                return [
                    'bg-light',
                    'text-dark',
                    'tabHeading',
                    'w-210',
                    'text-center',
                ]
            }
        },
        async getListData() {
            this.$store.commit('setLoading', true)
            try {
                let { data } = await listCustomizAPI.list({
                    dataSegmentId: this.dataSegmentId,
                })
                if (Array.isArray(data.data)) {
                    this.list = data.data
                    this.lastUpdatedAt = this.$moment(
                        data.lastUpdateDate
                    ).subtract(1, 'days')
                    this.lastListUpdatedAt = this.$moment(
                        data.lastListUpdatedAte
                    )
                }
            } catch (e) {
                console.log('error:', e)
            }
            this.$store.commit('setLoading', false)

            // console.log(this.formData)
            // console.log('this.lastUpdatedAt',this.lastUpdatedAt)
        },
        async resetCompleteList() {
            this.$store.commit('setLoading', true)
            await generate.list({
                dataSegmentId: this.dataSegmentId,
            })
            location.reload()
        },
        async updateList() {
            this.$store.commit('setLoading', true)
            await request.put('configurations/categorize/updateMany', {
                fields: this.fieldsToUpdate,
            })
            location.reload()
        },
        addFieldToUpdate(data) {
            if (data._id) {
                let fields = [...this.fieldsToUpdate].filter(
                    (el) => el._id != data._id
                )
                this.fieldsToUpdate = [...fields, { ...data }]
                return
            }

            // edit parent/ country
            this.list = this.list.map((el) => {
                if (
                    el.category == data.category &&
                    el.country == data.country
                ) {
                    el.status = data.status
                    el.data = el.data.map((subEl) => {
                        subEl.status = data.status
                        let fields = [...this.fieldsToUpdate].filter(
                            (el) => el._id != data._id
                        )
                        this.fieldsToUpdate = [...fields, { ...subEl }]
                        return subEl
                    })
                }
                return el
            })
        },
    },
}
</script>

<style>
p {
    font-size: 14px;
}

.tabHeading {
    text-decoration: none !important;
    font-size: 15px !important;
    padding-top: 12px;
}

.badge-light {
    background-color: lightgray;
}

.badge-success {
    background-color: #8dcd83;
    color: white;
}

.value {
    font-weight: 600;
    display: inline-block;
}

.field,
.field .label {
    padding-bottom: 10px;
}

.icon-status {
    width: 24px;
    height: 24px;
    border-radius: 100%;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    top: -5px;
}

span.icon-status i {
    color: #fff;
    font-size: 12px;
}

span.icon-status.success {
    background-color: #00c535;
}

span.icon-status.danger {
    background-color: #c91f37;
}

.badge-pill {
    font-size: 14px;
    padding: 4px 12px;
}

.pdf-icon-custom div {
    width: 26px;
    display: inline-block;
    margin-left: 10px;
}

.border-bottom-2 {
    border-bottom-width: 2px !important;
}

.custom-pill-format {
    display: block;
    width: fit-content;
    margin-bottom: 3px;
}

.border-bottom-custom-1 {
    border-bottom: #695b5b 2px solid;
}

.customers-info-section {
    min-height: 254px;
}

.w-210 {
    min-width: 210px;
    width: fit-content;
}

.form-details .col-md-4,
.form-details .col-md-5,
.form-details .col-md-6,
.form-details .col-md-12 {
    padding-left: 0px;
}

.customers-info-section ul li {
    list-style-type: none;
}

.customer-info img {
    min-width: 60%;
    margin-left: auto;
    margin-right: auto;
}

.sticky-customer-card {
    top: 52px;
    position: sticky;
    background: white;
    z-index: 1;
    border-bottom: 1px rgba(99, 99, 99, 0.2);
    border-radius: 0px !important;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
</style>
